import { useExtendedWarrantyContext } from '@extendedWarranty/contexts/ExtendedWarrantyContext';
import { ActivationConfirmation, ActivationOverview, UploadSerialNumbers } from '@extendedWarranty/routes/dashboard';
import { useMemo } from 'react';

export const EWUploadFlowWrapper = () => {
    const { viewIndex } = useExtendedWarrantyContext();

    const view = useMemo(() => {
        switch (viewIndex) {
            default:
            case 1:
                return <UploadSerialNumbers />;
            case 2:
                return <ActivationOverview />;
            case 3:
                return <ActivationConfirmation />;
        }
    }, [viewIndex]);

    return view;
};
